/* eslint-disable max-len */
import { misc } from '@credits-utils/constants';

import { FAQ_IDS } from '../../../../constants';

const { SITE } = misc;


const getFaqAnswer = (i18n, openSeaUrl, siteId, faqId) => {
  const answers = {
    /* i18n-next-line only: ["pt-BR", "es-MX"] */
    [FAQ_IDS.QUESTION_ONE]: i18n.jsx.gettext(
      'Es un límite de dinero que te sirve como medio de pago para comprar en cuotas sin tarjeta en Mercado Libre y pagar lo que quieras en Mercado Pago. Para {0}activar la Línea de Crédito{1}, es posible que tengas que confirmar tu número de celular y validar tu identidad por seguridad. ¡Solo te tomará unos minutos!',
      {
        tags: {
          0: `<a target="_blank" href="${openSeaUrl}">`,
          1: '</a>',
        },
        wrapper: 'p',
      },
    ),
    /* i18n-next-line only: ["pt-BR", "es-MX"] */
    [FAQ_IDS.QUESTION_TWO]: i18n.jsx.gettext(
      'Cuando actives la Línea{0}de{0}Crédito conocerás el límite de compra de tu línea y ya podrás empezar a usarla. Siempre podrás consultar tu límite en la sección “Créditos”. A medida que la uses y pagues tus cuotas a tiempo, ¡tu límite podría ir aumentando!',
      {
        tags: {
          0: '&nbsp;',
        },
        wrapper: 'p',
      },
    ),
    [FAQ_IDS.QUESTION_THREE]: {
      /* i18n-next-line only: ["pt-BR"] */
      [SITE.MLB]: i18n.jsx.gettext(
        'Puedes pagar todas tus cuotas desde la sección "Créditos”, desde la app de Mercado Pago.{0}Paga con Pix, en efectivo, con tarjeta de débito, o con tu dinero disponible en Mercado Pago.',
        {
          tags: {
            0: '<br />',
          },
          wrapper: 'p',
        },
      ),
      /* i18n-next-line except: [MLA,MLB,MLM] */
      [SITE.MLM]: i18n.jsx.gettext(
        'Puedes pagar todas tus cuotas desde la sección “Creditos”, dentro de Mercado Libre o desde la app de Mercado Pago.{0} Para acreditación inmediata: con tarjeta de débito, en efectivo en tiendas OXXO, vía transferencia bancaria, o con tu dinero disponible en Mercado Pago.{0} También puedes pagar en efectivo en BBVA, Santander, Citibanamex, 7-Eleven, Extra, K y Circle K (acreditación en menos de 1 hora).',
        {
          tags: {
            0: '<br />',
          },
          wrapper: 'p',
        },
      ),
      /* i18n-next-line only: ["es-AR"] */
      [SITE.MLA]: i18n.jsx.gettext(
        'Puedes pagar todas tus cuotas desde la sección “Créditos”, dentro de Mercado Libre o desde la app de Mercado Pago.{0}Para acreditación inmediata: con tarjeta de débito, en efectivo, en cualquier RapiPago, con tarjeta de crédito Visa o Mastercard (en 1 solo pago), o con tu dinero disponible en Mercado Pago. También puedes pagar con Pago Fácil (de 1 a 2 horas) o a través de una transferencia a tu cuenta de Mercado Pago vía CVU (acreditación en minutos o hasta 24 horas).',
        {
          tags: {
            0: '<br />',
          },
          wrapper: 'p',
        },
      ),
    },
    [FAQ_IDS.QUESTION_FOUR]: i18n.jsx.gettext(
      'Todas las cuotas son fijas y mensuales. Siempre vas a poder ver el valor final antes de confirmar la compra.',
      {
        wrapper: 'p',
      },
    ),
    /* i18n-next-line except: [MLA,MLB,MLM] */
    [FAQ_IDS.QUESTION_FIVE]: i18n.jsx.gettext(
      'Cuando actives la Línea{0}de{0}Crédito, conocerás tu fecha de vencimiento. Siempre te avisaremos unos días antes para que no lo olvides. Además, podrás consultarla cuando quieras desde la sección “Creditos”.',
      {
        tags: {
          0: '&nbsp;',
        },
        wrapper: 'p',
      },
    ),
    [FAQ_IDS.QUESTION_SIX]: i18n.jsx.gettext(
      '¡No hay costos extras! La activación y el mantenimiento son gratuitos. Si no lo usas, no pagas.',
      {
        wrapper: 'p',
      },
    ),
  };
  if (faqId === FAQ_IDS.QUESTION_THREE) {
    return answers[faqId.toString()][siteId.toString()];
  }
  return answers[faqId.toString()];
};

export const getFaqSectionContent = ({ i18n, openSeaUrl, siteId }) => ({
  /* i18n-next-line except: [MLM] */
  title: i18n.jsx.gettext(
    '¿Tienes alguna duda? Te contamos más sobre la Línea{0}de{0}Crédito',
    {
      tags: {
        0: '&nbsp;',
      },
      wrapper: 'h3',
      className: 'faq-section__title',
    },
  ),
  faqs: [
    {
      id: FAQ_IDS.QUESTION_ONE,
      /* i18n-next-line only: ["pt-BR"] */
      question: i18n.gettext('¿Qué es la Línea de Crédito y cómo la activo?'),
      answer: getFaqAnswer(i18n, openSeaUrl, siteId, FAQ_IDS.QUESTION_ONE),
    },
    {
      id: FAQ_IDS.QUESTION_TWO,
      question: i18n.gettext(
        '¿Qué límite de compra tengo? ¿Se puede aumentar?',
      ),
      answer: getFaqAnswer(i18n, openSeaUrl, siteId, FAQ_IDS.QUESTION_TWO),
    },
    {
      id: FAQ_IDS.QUESTION_THREE,
      question: i18n.gettext('¿Cómo pago las cuotas?'),
      answer: getFaqAnswer(i18n, openSeaUrl, siteId, FAQ_IDS.QUESTION_THREE),
    },
    {
      id: FAQ_IDS.QUESTION_FOUR,
      question: i18n.gettext('¿Cómo son las cuotas?'),
      answer: getFaqAnswer(i18n, openSeaUrl, siteId, FAQ_IDS.QUESTION_FOUR),
    },
    {
      id: FAQ_IDS.QUESTION_FIVE,
      question: i18n.gettext('¿Cómo me entero del vencimiento de las cuotas?'),
      answer: getFaqAnswer(i18n, openSeaUrl, siteId, FAQ_IDS.QUESTION_FIVE),
    },
    {
      id: FAQ_IDS.QUESTION_SIX,
      question: i18n.gettext('¿Tiene costo de mantenimiento?'),
      answer: getFaqAnswer(i18n, openSeaUrl, siteId, FAQ_IDS.QUESTION_SIX),
    },
  ],
  showMoreCta: {
    showMoreText: i18n.gettext('Ver más'),
    showLessText: i18n.gettext('Ver menos'),
  },
});
